export default __webpack_public_path__ + "static/media/schedualing_icon_white.2eff06c0.svg";